import {
    RegionCode,
    NumericRegionCode,
} from '@aviv-estimation-funnel/estimation-data-models/enums';
import { PhoneNumberUtil } from 'google-libphonenumber';

const RegionCodeByCountryCode = Object.entries(NumericRegionCode).reduce((acc, [region, code]) => {
    acc[code] = region;
    return acc;
}, {} as Record<number, string>);

export const extractPhoneNumber = (
    rawPhoneNumber: string,
): {
    phoneNumber: string | number;
    phoneNumberRegionCode: (typeof RegionCode)[keyof typeof RegionCode];
} => {
    const phoneUtil = PhoneNumberUtil.getInstance();
    const parsedNumber = phoneUtil.parse(rawPhoneNumber);
    const countryCode = parsedNumber.getCountryCode();
    const phoneNumber = parsedNumber.getNationalNumber();

    if (!countryCode || !phoneNumber) {
        throw new Error('Invalid phone number');
    }

    return {
        phoneNumber: phoneNumber.toString(),
        phoneNumberRegionCode: RegionCodeByCountryCode[
            countryCode
        ] as (typeof RegionCode)[keyof typeof RegionCode],
    };
};
